var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit ? '编辑':'添加') + "帐号"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c("el-form", {
    key: _vm.preventKey,
    ref: "ruleForm",
    tag: "component",
    staticClass: "form-beauty form-col",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobilephone"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.mobilephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilephone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "一级部门",
      "prop": "firDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.firDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "firDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.firDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "二级部门",
      "prop": "secDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.secDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "secDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.secDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "三级部门",
      "prop": "thrDeptName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.thrDeptName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "thrDeptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.thrDeptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "外包工号",
      "prop": "jobNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "jobNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.jobNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "外包公司邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "disabled": _vm.ruleForm.state == 1,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并继续添加")]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4c55aa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/bole/addBoleDialog.vue
// module id = null
// module chunks = 